import React, {Component} from 'react';
import './App.css';
import {
    Redirect, Link
} from "react-router-dom";
import FieldText from '@atlaskit/field-text'
import Select from '@atlaskit/select'
import Form from '@atlaskit/form';
import {auth,database} from './firebaseconfig'
import AsyncButton from './components/AsyncButton'


class Register extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            name: "",
            email: "",
            password: "",
            data: {
                loading: false
            }
        }
        this.onChange = this.onChange.bind(this)
        this.onSubmit = this.onSubmit.bind(this)
    }

    onChange(e) {
        this.setState({[e.target.name]: e.target.value});
    };

    onSelectChange = (choice, name) => {
        this.setState({[name]: choice.value});
    }

    yyyymmdd() {
        let x = new Date();
        let y = x.getFullYear().toString();
        let m = (x.getMonth() + 1).toString();
        let d = x.getDate().toString();
        if (d.length == 1) {
            d = '0' + d
        }
        if (m.length == 1) {
            m = '0' + m
        }
        const yyyymmdd = y + m + d;
        return yyyymmdd;
    }



    onSubmit() {
        const email = encodeURIComponent(this.state.email).replace(/\./g, '%2E')
        this.setState({data: {loading: true}})
        const date = this.yyyymmdd()
        auth.createUserWithEmailAndPassword(this.state.email, this.state.password)
            .then((id) => {
                const uid = id.user.uid
                database.collection(`/students`).doc(uid).set(
                    {
                        "email": email,
                        "name": this.state.name,
                        "dateCreated": date
                    }
                )
                    .then(() => {
                        this.props.history.push('/students')
                        this.setState({data: {loading: false}})
                    })
                    .catch(err => {
                        console.log(err)
                        this.setState({data: {loading: false}})
                    })
            })
            .catch(err => {
                console.log(err)
                this.setState({data: {loading: false}})
            })
    }

    render() {
        console.log(this.state)
        const {name, email, college, password} = this.state

        const schOptions = [
            {label: "School of Chemical and Biomedical Engineering"},
            {label: "School of Civil and Environmental Engineering"},
            {label: "School of Computer Science and Engineering"},
            {label: "School of Electrical and Electronic Engineering"},
            {label: "School of Materials Science and Engineering"},
            {label: "School of Mechanical and Aerospace Engineering"},
            {label: "School of Art Design and Media"},
            {label: "School of Humanities"},
            {label: "School of Social Sciences"},
            {label: "Wee Kim Wee School of Communication and Information"},
            {label: "School of Biological Sciences"},
            {label: "School of Physical and Mathematical Sciences"},
            {label: "The Asian School of the Environment"},
            {label: "Nanyang Business School"},
            {label: "Others"}
        ].map((each,index) => {
            return (
                {label: each.label, value: index}
            )
        })
            return (
                <div className="registerlogin-bg">
                    <img width="100" src="/img/whiteicon.svg"/>
                    <h3 style={{color: "white", marginTop: "30px",}} className="text-center">Register</h3>
                    <div className="login-form-container">
                        <Form
                            name="layout-example"
                            onSubmit={this.onSubmit}
                        >
                            <FieldText
                                onChange={this.onChange}
                                name="email"
                                label="Email"
                                type="email"
                                autoComplete="on"

                                shouldFitContainer
                                value={email}
                            />
                            <FieldText
                                onChange={this.onChange}
                                name="password"
                                label="Password"
                                type="password"
                                autoComplete="on"

                                shouldFitContainer
                                value={password}
                            />
                            <FieldText
                                onChange={this.onChange}
                                name="name"
                                label="Name"
                                autocomplete="given-name"

                                shouldFitContainer
                                value={name}
                            />
                            <div style={{marginTop: '20px'}}>
                                <AsyncButton type={"submit"} isFullWidth buttonText="Register" loading={this.state.data.loading}/>
                            </div>
                            <h3 style={{fontSize: '13px', marginTop: '20px'}}><Link to={`/login`}>Or login here ></Link></h3>
                        </Form>
                        <small style={{color: "white"}}>
                            By submitting this form, I consent to the collection and use of my personal data and information by Parallebs for the purpose of a pre-course analysis.
                        </small>
                    </div>
                </div>
            )
        }
    }

export default Register


// WEBPACK FOOTER //
// ./src/Register.js